const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);

export type LeaveTab = 'mine' | 'approvals' | 'planner';
const TABS = ['mine', 'approvals', 'planner'];

/** URL state of the leave page: the tab, the planner's month and whether it shows the whole company. */
export interface LeaveSearch {
  tab?: LeaveTab;
  /** `YYYY-MM`. */
  month?: string;
  everyone?: '1';
  /** Approvals: also show what was already decided. */
  history?: '1';
}

export function parseLeaveSearch(raw: Record<string, unknown>): LeaveSearch {
  const tab = str(raw.tab);
  const month = str(raw.month);
  return { tab: tab && TABS.includes(tab) ? (tab as LeaveTab) : undefined, month: month && /^\d{4}-(0[1-9]|1[0-2])$/.test(month) ? month : undefined, everyone: raw.everyone === '1' || raw.everyone === 1 ? '1' : undefined, history: raw.history === '1' || raw.history === 1 ? '1' : undefined };
}

export type LeaveAdminTab = 'balances' | 'types' | 'policies' | 'calendars';
const ADMIN_TABS = ['balances', 'types', 'policies', 'calendars'];

export type ContractsScope = 'ending' | 'ended' | 'draft' | 'all';
const SCOPES = ['ending', 'ended', 'draft', 'all'];

export interface LeaveAdminSearch {
  tab?: LeaveAdminTab;
  q?: string;
  negative?: '1';
  /** Which contracts the list shows; none = the current contract of each person. */
  contracts?: ContractsScope;
}

export function parseLeaveAdminSearch(raw: Record<string, unknown>): LeaveAdminSearch {
  const tab = str(raw.tab);
  const contracts = str(raw.contracts);
  return { tab: tab && ADMIN_TABS.includes(tab) ? (tab as LeaveAdminTab) : undefined, q: str(raw.q), negative: raw.negative === '1' || raw.negative === 1 ? '1' : undefined, contracts: contracts && SCOPES.includes(contracts) ? (contracts as ContractsScope) : undefined };
}
